import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NavService } from './../navigation/navigation.service';

@Component({
  selector: 'pax-cf-form-dispatcher',
  template: `<div class="component-loading">
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" aria-hidden="true"></i>
  </div>`
})
export class FormDispatcherComponent implements OnInit {
  storeData;

  constructor(
    private _router: Router,
    private _ns: NavService
  ) {}

  ngOnInit() {
    this._router.navigate([this._ns.activeStep]);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-dispatcher/form-dispatcher.component.ts